import { useState, useEffect, useContext } from 'react';
import { NavLink, Link, useParams } from "react-router-dom";

import { NotificationsContext } from '../../../components/app/contexts/NotificationsContext';
import { ApiContext } from '../../../components/app/contexts/ApiContext';


function UserDeleteModalScreen(props) {

  const notifications = useContext(NotificationsContext);
  const api = useContext(ApiContext);

  const users = props.users;
  const usersSelected = props.usersSelected;

  const [deleteModal, setDeleteModal] = props.deleteModal;
  const getData = props.getData;

  var modalStateClass = ' uk-open';


  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    await usersSelected.forEach(async (item, i) => {
      const response = await api.users.delete(
        item.value
      );
    });

    notifications.users.notification('user_deleted')

    setTimeout(async function(){
      await getData();
      await handleCancel(e);
    }, 2500);

    return false;
  }


  const handleCancel = (e) => {
    e.preventDefault();
    e.stopPropagation();

    setDeleteModal([]);
    return false;
  }



  return (

    <div id="messages-modal" className={"uk-modal" + modalStateClass} data-uk-modal style={{display: 'block'}}>
      <div className="uk-modal-dialog">
        <form id="hierModalForm" className="uk-form-stacked" onSubmit={handleSubmit}>
          <button className="uk-modal-close-default" data-uk-close type="button" onClick={handleCancel}></button>
          <div className="uk-modal-header">
            <h4 className="uk-modal-title">Пожалуйста, подтвердите удаление пользователей</h4>
          </div>
          <div className="uk-modal-footer uk-text-right">
            <button className="uk-button uk-button-default" type="button" onClick={handleCancel}>Отмена</button>
            <button className="uk-button uk-button-danger custom-button-danger" type="submit">Удалить</button>
          </div>
        </form>
      </div>
    </div>

  )
}

export default UserDeleteModalScreen;
